import {Exclude, Expose} from 'class-transformer';
import {BaseEntity} from '../../_helpers';

@Exclude()
export class DictionaryEntity extends BaseEntity {

  @Expose()
  public name: string;
}
